export default __webpack_public_path__ + "static/media/cloudnotUpload.f6832e32.svg";